import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { ChecklistsQuestion } from '../../interfaces/checklists-question.interface';
import { ComboBoxComponent, DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { TranslatePipe } from 'src/app/shared/pipes/translate/translate.pipe';
import { IconComponent } from 'src/app/shared/components/ui/icon/icon.component';
import { SearchComponent } from 'src/app/shared/components/ui/search/search.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'bizz-checklist-searchbar',
  standalone: true,
  imports: [DropDownsModule, IconComponent, TranslatePipe, SearchComponent, CommonModule],
  templateUrl: './searchbar.component.html',
  styleUrl: './searchbar.component.scss'
})
export class ChecklistSearchbarComponent {
  @Input() public set data(data:ChecklistsQuestion[]){
    this.filteredQuestions = this.questions = data;
  }
  public questions: ChecklistsQuestion[];
  public filteredQuestions: ChecklistsQuestion[];
  public searchTerm: string = '';
  @Input() public isMobileView: boolean = false;
  @Output() public valueChanged = new EventEmitter<ChecklistsQuestion>();
  @ViewChild('searchInput') public searchInput: SearchComponent;
  @Input() public show: boolean = false;

  public valueChange(selectedQuestion: ChecklistsQuestion): void{
    if(selectedQuestion){
      this.searchTerm = '';
      this.valueChanged.emit(selectedQuestion);
    }
  }

  public filterChange(filter: string): void {
    this.searchTerm = filter.toLowerCase();
    this.filteredQuestions = this.questions.filter(value => value.Question.toLowerCase().includes(this.searchTerm));
  }
 
  public focus(): void {
    this.searchInput.focus();
  }
}
